import type { ReleaseNotesPage } from '@scrambl/shared/types/release-notes'

import { apiClient } from './api-client'

export const releaseNotesApi = {
  list(page: number, pageSize = 4) {
    return apiClient<ReleaseNotesPage>(
      `/release-notes?page=${page}&pageSize=${pageSize}`,
    )
  },
}
